import * as types from './mutation-types'

const mutations = {
    [types.MITEL_CONNECTION_CHANGED](state, data){
        state.mitelConnectionStatus = data;
    },
    [types.SET_MITEL_CALL_CODE](state,data) {
        state.mitelCallCode = data;
    },
    [types.SET_MITEL_CALLER_NAME](state,data) {
        state.mitelCallerName = data;
    },
    [types.SET_MITEL_CALLER_NUMBER](state,data) {
        state.mitelCallerNumber = data;
    },
}

export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js